/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'diamond': {
    width: 20,
    height: 18,
    viewBox: '0 0 20 18',
    data: '<path pid="0" d="M19.658 5.043L16.902.908A2.034 2.034 0 0015.205 0H4.8c-.683 0-1.317.338-1.697.908L.344 5.043a2.032 2.032 0 00.19 2.505l8.533 9.37c.239.26.58.412.934.412.354 0 .696-.151.934-.412l8.533-9.37a2.04 2.04 0 00.19-2.505zm-3.561-3.6l2.756 4.134c.058.087.103.184.132.28h-4.66L13.016.963h2.187c.36.003.695.18.895.48zM10 15.772L6.723 6.826h6.553l-3.275 8.946zM12.014.966l1.31 4.894h-6.65L7.986.966h4.029zm-8.108.477c.2-.3.534-.48.895-.48h2.186l-1.31 4.894h-4.66a1.06 1.06 0 01.132-.28l2.757-4.134zM1.188 6.826h4.508l3.036 8.289L1.25 6.897c-.022-.022-.042-.048-.061-.07zm10.082 8.289l3.036-8.289h4.508a1.24 1.24 0 01-.06.075l-7.484 8.214z" _fill="#333" fill-rule="evenodd"/>'
  }
})
